import {combineReducers} from 'redux'
import UserManagementContainer from './container/UserManagementContainer';

import userRoleReducer from './reducers/userRoleReducer';
import usersReducers from './reducers/usersReducers';
import userGroupsReducers from './reducers/userGroupsReducers';
import miniLibraryReducers from './reducers/miniLibraryReducers';

const components = { UserManagementContainer };

const reducers = combineReducers({
  userRoleList: userRoleReducer,
  users: usersReducers,
  userGroups: userGroupsReducers,
  miniLibrary: miniLibraryReducers,
});

export { components, reducers };